import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ServiceIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "48",
                height: "48",
                rx: "8",
                fill: "#FA4270"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.661 14.8509C13.2565 15.8638 12.084 18.3982 13.1735 20.9858C14.5822 24.3309 20.7807 26.2303 21.0722 26.2728C21.334 26.3133 21.6404 26.1622 21.6404 25.8728C21.6404 25.5834 21.0722 23.1797 21.0722 23.0094C21.0722 22.8392 21.168 22.686 21.3318 22.6179C21.4957 22.5498 28.6837 19.5026 31.0669 18.5003C33.4502 17.4981 34.5801 14.7999 33.5544 12.3655C32.5288 9.93115 29.8157 8.86931 27.4197 9.87795C25.0237 10.8866 18.0655 13.8402 15.661 14.8509Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M32.3122 33.1464C34.7167 32.1335 35.8892 29.5992 34.7997 27.0116C33.391 23.6665 27.1925 21.7795 26.901 21.7369C26.6392 21.6965 26.3328 21.8476 26.3328 22.1369C26.3328 22.4263 26.901 24.8177 26.901 24.9879C26.901 25.1582 26.8052 25.3114 26.6414 25.3795C26.4775 25.4476 19.2895 28.4948 16.9063 29.497C14.523 30.4993 13.3931 33.1975 14.4188 35.6319C15.4444 38.0684 18.1575 39.1281 20.5535 38.1194C22.9516 37.1108 29.9077 34.1572 32.3122 33.1464Z",
                fill: "white"
            })
        ]
    });
